export default __webpack_public_path__ + "static/media/this-Site.1cac4d23.jpg";